"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shaftPower = exports.pressure = exports.airFlow = exports.actualDensity = exports.airInputsMassflow = exports.airInputsPressure = exports.airInputsHumidity = exports.airInputsTemperature = exports.altitude = exports.targetPressure = exports.inverterEfficiency = exports.inverter = exports.driveRatio = exports.driveEfficiency = exports.driveType = exports.fanMaximumSpeed = exports.fanMinimumSpeed = exports.motorOverspeedDerateFactor = exports.motorCosphi = exports.motorLag = exports.motorMaximumSpeed = exports.motorMinimumSpeed = exports.motorNominalSpeed = exports.motorBaseFrequency = exports.motorEfficiency = exports.motorPoles = exports.motorPhases = exports.motorVoltage = exports.motorNominalPower = exports.fanDynamicPressureLossCoefficient = exports.fanOutletArea = exports.fanDefinitionStandardDensity = exports.fanDefinitionSpeed = exports.fanQuantity = exports.fanControlMode = void 0;
exports.fanControlMode = "fmptcontrolmode";
exports.fanQuantity = "fmptfanquantity";
exports.fanDefinitionSpeed = "fmptfandefinitionspeed";
exports.fanDefinitionStandardDensity = "fmptfandefinitionstandarddensity";
exports.fanOutletArea = "fmptfanoutletarea";
exports.fanDynamicPressureLossCoefficient = "fmptfandynamicpressurelosscoefficient";
exports.motorNominalPower = "fmptmotornominalpower";
exports.motorVoltage = "fmptmotorvoltage";
exports.motorPhases = "fmptmotorphases";
exports.motorPoles = "fmptmotorpoles";
exports.motorEfficiency = "fmptmotorefficiency";
exports.motorBaseFrequency = "fmptmotorbasefrequency";
exports.motorNominalSpeed = "fmptmotornominalspeed";
exports.motorMinimumSpeed = "fmptmotorminimumspeed";
exports.motorMaximumSpeed = "fmptmotormaximumspeed";
exports.motorLag = "fmptmotorlag";
exports.motorCosphi = "fmptmotorcosphi";
exports.motorOverspeedDerateFactor = "fmptmotoroverspeedderatefactor";
exports.fanMinimumSpeed = "fmptfanminimumspeed";
exports.fanMaximumSpeed = "fmptfanmaximumspeed";
exports.driveType = "fmptdrivetype";
exports.driveEfficiency = "fmptdriveefficiency";
exports.driveRatio = "fmptdriveratio";
exports.inverter = "fmptinverter";
exports.inverterEfficiency = "fmptinverterefficiency";
exports.targetPressure = "targetpressure";
exports.altitude = "altitude";
exports.airInputsTemperature = "airinputstemperature";
exports.airInputsHumidity = "airinputshumidity";
exports.airInputsPressure = "airinputspressure";
exports.airInputsMassflow = "airinputsmassflow";
exports.actualDensity = "actualdensity";
exports.airFlow = "airflow";
exports.pressure = "pressure";
exports.shaftPower = "shaftpower";
//# sourceMappingURL=known-properties.js.map